import { render, staticRenderFns } from "./recommandations.vue?vue&type=template&id=df183fc8&scoped=true&"
import script from "./recommandations.vue?vue&type=script&lang=js&"
export * from "./recommandations.vue?vue&type=script&lang=js&"
import style0 from "./recommandations.vue?vue&type=style&index=0&id=df183fc8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df183fc8",
  null
  
)

export default component.exports